import { createCrudHooks } from './base'
import { trpc } from '../trpc'
import type {
  ServicePackageWithVersions,
  ServicePackage,
  ServicePackageInsert,
  ServicePackageUpdate,
  PackageVersionTask,
  ServicePackageVersionWithTasks,
  ServicePackageVersion,
  ServicePackageVersionInsert,
  ServicePackageVersionUpdate,
} from '@markku/types'

// Service package hooks
export const servicePackageHooks = {
  ...createCrudHooks<
    ServicePackageWithVersions,
    ServicePackage,
    ServicePackageInsert,
    ServicePackageUpdate
  >('servicePackage'),

  // Custom hook for area-based package filtering
  // Pass floorArea directly so React Query automatically refetches when it changes
  useListActive: (floorArea?: number | null) => {
    return trpc.servicePackage.listActive.useQuery({ floorArea })
  },
}

// Service package version hooks
export const servicePackageVersionHooks = createCrudHooks<
  ServicePackageVersionWithTasks,
  ServicePackageVersion,
  ServicePackageVersionInsert,
  ServicePackageVersionUpdate
>('servicePackageVersion')

// Package version task hooks - uses top-level packageVersionTask router
export const packageVersionTaskHooks =
  createCrudHooks<PackageVersionTask>('packageVersionTask')
